const DocExtension = ['png', 'jpg', 'jpeg', 'pdf', 'dwg', 'dwf', 'rar', 'zip'];
const NCsCsExtension = ['png', 'jpg', 'jpeg', 'pdf', 'mp4'];

export { DocExtension, NCsCsExtension };
